// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/ms_teams/v1/ms_teams.proto" (package "c1.api.ms_teams.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLRequest
 */
export interface GeneratePublicApplicationPermissionsConsentURLRequest {
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLResponse
 */
export interface GeneratePublicApplicationPermissionsConsentURLResponse {
    /**
     * @generated from protobuf field: string url = 1
     */
    url: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.DefaultTeam
 */
export interface DefaultTeam {
    /**
     * @generated from protobuf field: string team_id = 1
     */
    teamId: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp selected_at = 3
     */
    selectedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.MSTeamsDirectoryBinding
 */
export interface MSTeamsDirectoryBinding {
    /**
     * @generated from protobuf field: string external_directory_id = 1
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string hostname = 2
     */
    hostname: string;
    /**
     * @generated from protobuf field: bool has_admin_consent = 3
     */
    hasAdminConsent: boolean;
    /**
     * @generated from protobuf field: c1.api.ms_teams.v1.DefaultTeam default_team = 4
     */
    defaultTeam?: DefaultTeam;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.MSTeam
 */
export interface MSTeam {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SearchMSTeamsTeamsRequest
 */
export interface SearchMSTeamsTeamsRequest {
    /**
     * @generated from protobuf field: string external_directory_id = 1
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string query = 2
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SearchMSTeamsTeamsResponse
 */
export interface SearchMSTeamsTeamsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.ms_teams.v1.MSTeam teams = 1
     */
    teams: MSTeam[];
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SetDefaultMSTeamsTeamRequest
 */
export interface SetDefaultMSTeamsTeamRequest {
    /**
     * @generated from protobuf field: string external_directory_id = 1
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string team_id = 2
     */
    teamId: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SetDefaultMSTeamsTeamResponse
 */
export interface SetDefaultMSTeamsTeamResponse {
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsRequest
 */
export interface ListMSTeamsDirectoryBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsResponse
 */
export interface ListMSTeamsDirectoryBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.ms_teams.v1.MSTeamsDirectoryBinding list = 1
     */
    list: MSTeamsDirectoryBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingRequest
 */
export interface DeleteMSTeamsDirectoryBindingRequest {
    /**
     * @generated from protobuf field: string external_directory_id = 1
     */
    externalDirectoryId: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingResponse
 */
export interface DeleteMSTeamsDirectoryBindingResponse {
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.MSTeamsDirectoryBindingRef
 */
export interface MSTeamsDirectoryBindingRef {
    /**
     * @generated from protobuf field: string external_directory_id = 1
     */
    externalDirectoryId: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsRequest
 */
export interface SearchMSTeamsDirectoryBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string external_directory_id = 3
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string hostname = 4
     */
    hostname: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsResponse
 */
export interface SearchMSTeamsDirectoryBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.ms_teams.v1.MSTeamsDirectoryBinding list = 1
     */
    list: MSTeamsDirectoryBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class GeneratePublicApplicationPermissionsConsentURLRequest$Type extends MessageType<GeneratePublicApplicationPermissionsConsentURLRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLRequest", []);
    }
    create(value?: PartialMessage<GeneratePublicApplicationPermissionsConsentURLRequest>): GeneratePublicApplicationPermissionsConsentURLRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GeneratePublicApplicationPermissionsConsentURLRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GeneratePublicApplicationPermissionsConsentURLRequest): GeneratePublicApplicationPermissionsConsentURLRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GeneratePublicApplicationPermissionsConsentURLRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLRequest
 */
export const GeneratePublicApplicationPermissionsConsentURLRequest = new GeneratePublicApplicationPermissionsConsentURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneratePublicApplicationPermissionsConsentURLResponse$Type extends MessageType<GeneratePublicApplicationPermissionsConsentURLResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { uri: true } } } }
        ]);
    }
    create(value?: PartialMessage<GeneratePublicApplicationPermissionsConsentURLResponse>): GeneratePublicApplicationPermissionsConsentURLResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial<GeneratePublicApplicationPermissionsConsentURLResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GeneratePublicApplicationPermissionsConsentURLResponse): GeneratePublicApplicationPermissionsConsentURLResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GeneratePublicApplicationPermissionsConsentURLResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLResponse
 */
export const GeneratePublicApplicationPermissionsConsentURLResponse = new GeneratePublicApplicationPermissionsConsentURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DefaultTeam$Type extends MessageType<DefaultTeam> {
    constructor() {
        super("c1.api.ms_teams.v1.DefaultTeam", [
            { no: 1, name: "team_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 3, name: "selected_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<DefaultTeam>): DefaultTeam {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.teamId = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<DefaultTeam>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DefaultTeam): DefaultTeam {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string team_id */ 1:
                    message.teamId = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* google.protobuf.Timestamp selected_at */ 3:
                    message.selectedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.selectedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DefaultTeam, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string team_id = 1; */
        if (message.teamId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.teamId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* google.protobuf.Timestamp selected_at = 3; */
        if (message.selectedAt)
            Timestamp.internalBinaryWrite(message.selectedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.DefaultTeam
 */
export const DefaultTeam = new DefaultTeam$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeamsDirectoryBinding$Type extends MessageType<MSTeamsDirectoryBinding> {
    constructor() {
        super("c1.api.ms_teams.v1.MSTeamsDirectoryBinding", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hostname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "has_admin_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "default_team", kind: "message", T: () => DefaultTeam }
        ]);
    }
    create(value?: PartialMessage<MSTeamsDirectoryBinding>): MSTeamsDirectoryBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalDirectoryId = "";
        message.hostname = "";
        message.hasAdminConsent = false;
        if (value !== undefined)
            reflectionMergePartial<MSTeamsDirectoryBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MSTeamsDirectoryBinding): MSTeamsDirectoryBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string external_directory_id */ 1:
                    message.externalDirectoryId = reader.string();
                    break;
                case /* string hostname */ 2:
                    message.hostname = reader.string();
                    break;
                case /* bool has_admin_consent */ 3:
                    message.hasAdminConsent = reader.bool();
                    break;
                case /* c1.api.ms_teams.v1.DefaultTeam default_team */ 4:
                    message.defaultTeam = DefaultTeam.internalBinaryRead(reader, reader.uint32(), options, message.defaultTeam);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MSTeamsDirectoryBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string external_directory_id = 1; */
        if (message.externalDirectoryId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.externalDirectoryId);
        /* string hostname = 2; */
        if (message.hostname !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.hostname);
        /* bool has_admin_consent = 3; */
        if (message.hasAdminConsent !== false)
            writer.tag(3, WireType.Varint).bool(message.hasAdminConsent);
        /* c1.api.ms_teams.v1.DefaultTeam default_team = 4; */
        if (message.defaultTeam)
            DefaultTeam.internalBinaryWrite(message.defaultTeam, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.MSTeamsDirectoryBinding
 */
export const MSTeamsDirectoryBinding = new MSTeamsDirectoryBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeam$Type extends MessageType<MSTeam> {
    constructor() {
        super("c1.api.ms_teams.v1.MSTeam", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<MSTeam>): MSTeam {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<MSTeam>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MSTeam): MSTeam {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MSTeam, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.MSTeam
 */
export const MSTeam = new MSTeam$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMSTeamsTeamsRequest$Type extends MessageType<SearchMSTeamsTeamsRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.SearchMSTeamsTeamsRequest", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchMSTeamsTeamsRequest>): SearchMSTeamsTeamsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalDirectoryId = "";
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<SearchMSTeamsTeamsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchMSTeamsTeamsRequest): SearchMSTeamsTeamsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string external_directory_id */ 1:
                    message.externalDirectoryId = reader.string();
                    break;
                case /* string query */ 2:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchMSTeamsTeamsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string external_directory_id = 1; */
        if (message.externalDirectoryId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.externalDirectoryId);
        /* string query = 2; */
        if (message.query !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SearchMSTeamsTeamsRequest
 */
export const SearchMSTeamsTeamsRequest = new SearchMSTeamsTeamsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMSTeamsTeamsResponse$Type extends MessageType<SearchMSTeamsTeamsResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.SearchMSTeamsTeamsResponse", [
            { no: 1, name: "teams", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MSTeam }
        ]);
    }
    create(value?: PartialMessage<SearchMSTeamsTeamsResponse>): SearchMSTeamsTeamsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.teams = [];
        if (value !== undefined)
            reflectionMergePartial<SearchMSTeamsTeamsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchMSTeamsTeamsResponse): SearchMSTeamsTeamsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.ms_teams.v1.MSTeam teams */ 1:
                    message.teams.push(MSTeam.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchMSTeamsTeamsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.ms_teams.v1.MSTeam teams = 1; */
        for (let i = 0; i < message.teams.length; i++)
            MSTeam.internalBinaryWrite(message.teams[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SearchMSTeamsTeamsResponse
 */
export const SearchMSTeamsTeamsResponse = new SearchMSTeamsTeamsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDefaultMSTeamsTeamRequest$Type extends MessageType<SetDefaultMSTeamsTeamRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.SetDefaultMSTeamsTeamRequest", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "team_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } }
        ]);
    }
    create(value?: PartialMessage<SetDefaultMSTeamsTeamRequest>): SetDefaultMSTeamsTeamRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalDirectoryId = "";
        message.teamId = "";
        if (value !== undefined)
            reflectionMergePartial<SetDefaultMSTeamsTeamRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetDefaultMSTeamsTeamRequest): SetDefaultMSTeamsTeamRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string external_directory_id */ 1:
                    message.externalDirectoryId = reader.string();
                    break;
                case /* string team_id */ 2:
                    message.teamId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetDefaultMSTeamsTeamRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string external_directory_id = 1; */
        if (message.externalDirectoryId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.externalDirectoryId);
        /* string team_id = 2; */
        if (message.teamId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.teamId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SetDefaultMSTeamsTeamRequest
 */
export const SetDefaultMSTeamsTeamRequest = new SetDefaultMSTeamsTeamRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDefaultMSTeamsTeamResponse$Type extends MessageType<SetDefaultMSTeamsTeamResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.SetDefaultMSTeamsTeamResponse", []);
    }
    create(value?: PartialMessage<SetDefaultMSTeamsTeamResponse>): SetDefaultMSTeamsTeamResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetDefaultMSTeamsTeamResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetDefaultMSTeamsTeamResponse): SetDefaultMSTeamsTeamResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetDefaultMSTeamsTeamResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SetDefaultMSTeamsTeamResponse
 */
export const SetDefaultMSTeamsTeamResponse = new SetDefaultMSTeamsTeamResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMSTeamsDirectoryBindingsRequest$Type extends MessageType<ListMSTeamsDirectoryBindingsRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListMSTeamsDirectoryBindingsRequest>): ListMSTeamsDirectoryBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListMSTeamsDirectoryBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListMSTeamsDirectoryBindingsRequest): ListMSTeamsDirectoryBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListMSTeamsDirectoryBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsRequest
 */
export const ListMSTeamsDirectoryBindingsRequest = new ListMSTeamsDirectoryBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMSTeamsDirectoryBindingsResponse$Type extends MessageType<ListMSTeamsDirectoryBindingsResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MSTeamsDirectoryBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListMSTeamsDirectoryBindingsResponse>): ListMSTeamsDirectoryBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListMSTeamsDirectoryBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListMSTeamsDirectoryBindingsResponse): ListMSTeamsDirectoryBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.ms_teams.v1.MSTeamsDirectoryBinding list */ 1:
                    message.list.push(MSTeamsDirectoryBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListMSTeamsDirectoryBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.ms_teams.v1.MSTeamsDirectoryBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            MSTeamsDirectoryBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsResponse
 */
export const ListMSTeamsDirectoryBindingsResponse = new ListMSTeamsDirectoryBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMSTeamsDirectoryBindingRequest$Type extends MessageType<DeleteMSTeamsDirectoryBindingRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingRequest", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteMSTeamsDirectoryBindingRequest>): DeleteMSTeamsDirectoryBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalDirectoryId = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteMSTeamsDirectoryBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteMSTeamsDirectoryBindingRequest): DeleteMSTeamsDirectoryBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string external_directory_id */ 1:
                    message.externalDirectoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteMSTeamsDirectoryBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string external_directory_id = 1; */
        if (message.externalDirectoryId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.externalDirectoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingRequest
 */
export const DeleteMSTeamsDirectoryBindingRequest = new DeleteMSTeamsDirectoryBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMSTeamsDirectoryBindingResponse$Type extends MessageType<DeleteMSTeamsDirectoryBindingResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingResponse", []);
    }
    create(value?: PartialMessage<DeleteMSTeamsDirectoryBindingResponse>): DeleteMSTeamsDirectoryBindingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteMSTeamsDirectoryBindingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteMSTeamsDirectoryBindingResponse): DeleteMSTeamsDirectoryBindingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteMSTeamsDirectoryBindingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingResponse
 */
export const DeleteMSTeamsDirectoryBindingResponse = new DeleteMSTeamsDirectoryBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeamsDirectoryBindingRef$Type extends MessageType<MSTeamsDirectoryBindingRef> {
    constructor() {
        super("c1.api.ms_teams.v1.MSTeamsDirectoryBindingRef", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } }
        ]);
    }
    create(value?: PartialMessage<MSTeamsDirectoryBindingRef>): MSTeamsDirectoryBindingRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalDirectoryId = "";
        if (value !== undefined)
            reflectionMergePartial<MSTeamsDirectoryBindingRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MSTeamsDirectoryBindingRef): MSTeamsDirectoryBindingRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string external_directory_id */ 1:
                    message.externalDirectoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MSTeamsDirectoryBindingRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string external_directory_id = 1; */
        if (message.externalDirectoryId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.externalDirectoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.MSTeamsDirectoryBindingRef
 */
export const MSTeamsDirectoryBindingRef = new MSTeamsDirectoryBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMSTeamsDirectoryBindingsRequest$Type extends MessageType<SearchMSTeamsDirectoryBindingsRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", ignoreEmpty: true } } } },
            { no: 4, name: "hostname", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<SearchMSTeamsDirectoryBindingsRequest>): SearchMSTeamsDirectoryBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.externalDirectoryId = "";
        message.hostname = "";
        if (value !== undefined)
            reflectionMergePartial<SearchMSTeamsDirectoryBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchMSTeamsDirectoryBindingsRequest): SearchMSTeamsDirectoryBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string external_directory_id */ 3:
                    message.externalDirectoryId = reader.string();
                    break;
                case /* string hostname */ 4:
                    message.hostname = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchMSTeamsDirectoryBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string external_directory_id = 3; */
        if (message.externalDirectoryId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalDirectoryId);
        /* string hostname = 4; */
        if (message.hostname !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.hostname);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsRequest
 */
export const SearchMSTeamsDirectoryBindingsRequest = new SearchMSTeamsDirectoryBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMSTeamsDirectoryBindingsResponse$Type extends MessageType<SearchMSTeamsDirectoryBindingsResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MSTeamsDirectoryBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchMSTeamsDirectoryBindingsResponse>): SearchMSTeamsDirectoryBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchMSTeamsDirectoryBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchMSTeamsDirectoryBindingsResponse): SearchMSTeamsDirectoryBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.ms_teams.v1.MSTeamsDirectoryBinding list */ 1:
                    message.list.push(MSTeamsDirectoryBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchMSTeamsDirectoryBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.ms_teams.v1.MSTeamsDirectoryBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            MSTeamsDirectoryBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsResponse
 */
export const SearchMSTeamsDirectoryBindingsResponse = new SearchMSTeamsDirectoryBindingsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.ms_teams.v1.MSTeamsService
 */
export const MSTeamsService = new ServiceType("c1.api.ms_teams.v1.MSTeamsService", [
    { name: "ListMSTeamsDirectoryBindings", options: { "authz.method": { role: "OWNER" } }, I: ListMSTeamsDirectoryBindingsRequest, O: ListMSTeamsDirectoryBindingsResponse },
    { name: "DeleteMSTeamsDirectoryBinding", options: { "authz.method": { role: "OWNER" } }, I: DeleteMSTeamsDirectoryBindingRequest, O: DeleteMSTeamsDirectoryBindingResponse },
    { name: "GeneratePublicApplicationPermissionsConsentURL", options: { "authz.method": { role: "OWNER" } }, I: GeneratePublicApplicationPermissionsConsentURLRequest, O: GeneratePublicApplicationPermissionsConsentURLResponse },
    { name: "SearchMSTeamsTeams", options: { "authz.method": { role: "OWNER" } }, I: SearchMSTeamsTeamsRequest, O: SearchMSTeamsTeamsResponse },
    { name: "SetDefaultMSTeamsTeam", options: { "authz.method": { role: "OWNER" } }, I: SetDefaultMSTeamsTeamRequest, O: SetDefaultMSTeamsTeamResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.ms_teams.v1.MSTeamsSearchService
 */
export const MSTeamsSearchService = new ServiceType("c1.api.ms_teams.v1.MSTeamsSearchService", [
    { name: "SearchMSTeamsDirectoryBindings", options: { "authz.method": { role: "VIEWER" } }, I: SearchMSTeamsDirectoryBindingsRequest, O: SearchMSTeamsDirectoryBindingsResponse }
]);
